import React, { useState, useEffect } from "react";
import { db } from "../firebase";
import { collection, getDocs } from "firebase/firestore";
import "./AssignScreenModal.css";

const AssignScreenModal = ({ isOpen, onClose, onScreenAssigned }) => {
  const [screens, setScreens] = useState([]);

  useEffect(() => {
    const fetchScreens = async () => {
      try {
        const screensRef = collection(db, "screens");
        const querySnapshot = await getDocs(screensRef);
        setScreens(querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
      } catch (err) {
        console.error("❌ Error fetching screens:", err.message);
      }
    };

    if (isOpen) fetchScreens();
  }, [isOpen]);

  const handleAssign = (screen) => {
    onScreenAssigned(screen);
    onClose();
  };

  return (
    isOpen && (
      <div className="modal-overlay">
        <div className="modal-content">
          <h2>Select Screen</h2>
          <ul className="screen-list">
            {screens.map((screen) => (
              <li key={screen.id} onClick={() => handleAssign(screen)}>
                {screen.name}
              </li>
            ))}
          </ul>
          <button className="btn cancel" onClick={onClose}>Cancel</button>
        </div>
      </div>
    )
  );
};

export default AssignScreenModal;
